/**
 * 작성자 이름에서 원형 이니셜용 첫글자 반환
 * - 한글: 이름 첫글자 그대로
 * - 영문: 대문자 알파벳 첫글자
 * @param {string} [name] - 작성자 이름
 * @returns {string}
 */
export function getAuthorInitial(name) {
  if (name == null || typeof name !== 'string') return '';
  const trimmed = name.trim();
  if (!trimmed) return '';
  const first = trimmed.charAt(0);
  if (/[a-z]/i.test(first)) return first.toUpperCase();
  return first;
}
